import Vue from 'vue';
import moment from "moment";

const success = (context, response) => {
  // context.fetch_rental(context.rental.id) // Deprecated ? 
  if (response.msg) {
    toastr.success(response.msg);
  }
  context.hideDisabledWarning();
  if (response.connected !== undefined && !response.connected) {
    swal(context.$t('rentals.detail.modals.account_disconnected'), '', 'success');
  }
  if (response.action === "importing") {
    context.openModal('#sync-in-progress-modal');
    context.rental.airbnbConnectedDate = moment(response.connected_date).format(
      "ddd DD MMMM YYYY HH:mm:ss"
    );
  }
  if (response.action ===  "disconnect") {
    context.rental.airbnbConnectedDate = null;
  }
  context.loading = false;
};

const failed = (context, error) => {
  if (error && error.response && error.response.data && error.response.data.haveBookings) {
    context.removeAirbnbBookings();
  } else {
    // context.fetch_rental(context.rental.id) // Deprecated ? 
    context.showToasterError(error);
  }
  context.loading = false;
};

export default (context, data) => Vue.$http.post('rentals/edit-platforms', data)
    .then((response) => {
      success(context, response.data);
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/rental/editPlatforms.js